<script>
    import { ethers } from "ethers";
    import ITierArtifact from "../../abi/iTier.json";
    import {tierReport} from "../../utils";

    export let signer, tierData, minimumStatus, againstBlock, readableTiers, eligibleStatus;


    const checkTier = async (tier, minimumStatus) => {
        const report = await tier.report($signer.getAddress());
        const parsedReport = tierReport(report);
        if (minimumStatus !== 0) {
            for (let i = 0; i < 8; i++) {
                if (parsedReport[i] < againstBlock) {
                    eligibleStatus = i + 1;
                } else {
                    break;
                }
            }
        }
    };
    $: if ($signer && minimumStatus !== undefined && tierData?.id) {
        const tier = new ethers.Contract(tierData.id, ITierArtifact.abi, $signer);
        checkTier(tier, minimumStatus);
    }
</script>

{#if minimumStatus !== "0"}
    {#if eligibleStatus >= minimumStatus}
        <section class="gradient-border">✅ You are eligible for this Sale.</section>
    {:else}
        <section class="gradient-border">❌ You are not eligible for this sale as you are not part of this tier.</section>
    {/if}
{:else}
    <section class="gradient-border">This Sale is open for everyone.</section>
{/if}
